import React, { useEffect, useState } from "react";
import MobileProductsPage from "../mobile/produits/MobileProductsPage";
import GestionProduit from "./GestionProduit";

const MOBILE_QUERY = "(max-width: 768px)";

const getMatches = () =>
  typeof window !== "undefined" && window.matchMedia(MOBILE_QUERY).matches;

export default function ResponsiveGestionProduit() {
  const [isMobile, setIsMobile] = useState(getMatches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_QUERY);
    const handleChange = (event) => setIsMobile(event.matches);

    setIsMobile(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return isMobile ? <MobileProductsPage /> : <GestionProduit />;
}
